import { render } from "./page.analytics.vue?vue&type=template&id=21f5ecbc"
import script from "./page.analytics.vue?vue&type=script&lang=js"
export * from "./page.analytics.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__